/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum SizeUnit {
    Byte = 'byte',
    Kb = 'kb',
    Mb = 'mb',
    Gb = 'gb',
    Tb = 'tb',
    Pb = 'pb',
    Eb = 'eb'
};

